import { api } from '~/data/api'
import {
  IIdentity,
  IPaginated,
  IPaginatedMetadataResponse,
  IUser,
  IUserFilterParams,
} from '~/utils/types'
import { IUseListAllUsers } from './useData'

export async function createUser(user: IUser) {
  const response = await api().post('/user', user)
  return response.data
}

export async function inviteUser(user: IUser) {
  const response = await api().post(`/user/invite_user/${user.company}`, {
    profile: user.profile,
    to: (user.identity as IIdentity).email,
  })
  return response.data
}

export async function getUserById(id: string): Promise<IUser> {
  const response = await api().get(`/user/${id}`)

  return response.data as IUser
}

export interface IUpdateUserRequest {
  user: IUser
  user_id?: string
}

export async function listUserPaginated(props: IUserFilterParams): Promise<IPaginated<IUser>> {
  const response = await api().get(`/user/filter_users`, {
    params: {
      ...props.pagination,
      name: props.name ?? '',
    },
  })

  const metadata: IPaginatedMetadataResponse = {
    limit: response.data.limit,
    offset: (response.data.page - 1) * response.data.limit,
    total: response.data.total_count,
  }

  return {
    docs: response.data.users,
    metadata,
  }
}

export async function updateUser({ user, user_id }: IUpdateUserRequest) {
  const response = await api().patch(`/user/${user_id}`, user)
  return response.data
}

export async function deleteUser(id: string) {
  const response = await api().delete(`/user/${id}`)
  return response.data
}

export async function listAllUsers(params?: IUseListAllUsers): Promise<IUser[]> {
  const response = await api().get(`/user`, { params })
  return response.data as IUser[]
}

export async function searchIdentity(email: string): Promise<IIdentity> {
  const response = await api().post('/identity/find', {
    email,
  })
  return response.data as IIdentity
}

export interface ICreateIdentity {
  name: string
  email: string
  password?: string
}

export async function createIdentity(props: ICreateIdentity): Promise<IIdentity> {
  const response = await api().post('/identity/', props)
  return response.data as IIdentity
}

export interface IUpdateIdentity extends ICreateIdentity {
  identity_id: string
}

export async function updateIdentity(props: IUpdateIdentity): Promise<IIdentity> {
  const response = await api().put(`/identity/${props.identity_id}`, props)
  return response.data as IIdentity
}

export interface ISendWelcomeEmail {
  email: string
  password: string
  language: string
}

export async function sendWelcomeEmail(props: ISendWelcomeEmail) {
  await api().post(`/user/notify`, props)
}
